module.exports = __webpack_public_path__ + "static/media/alerta-combustible-verde.ad01bc4b.svg";